import { ScrollControls } from '@react-three/drei'
import { Canvas } from '@react-three/fiber'
import React from 'react'
import { LogoNavModel } from '../3D Components/LogoNavModel'
import * as THREE from 'three';

type mousePosition = {
  x: number;
  y: number;
}

type Nav3DAnimationType = {
  mousePosition: mousePosition,
}

export default function Nav3DAnimation(props: Nav3DAnimationType) {

 
  return (
    <div className='w-full h-screen'>
      <Canvas camera={{ position: [0, 0, 2], fov: 50 }} className="w-full h-screen">
        <ambientLight intensity={0.8} />
        <directionalLight position={[0, 5, 15]} intensity={1} />
        <LogoNavModel mousePosition={props.mousePosition}/>
      </Canvas>
    </div>
  )
}
